import { memo, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, Skeleton } from '@monksflow/monks-ui';
import type { ImagePreviewProps } from './ImagePreview.types';

/**
 * monks-ui preview dialog for an image attachment. Same footprint as the
 * legacy MUI `ImagePreview` (max-w-148) but built on the Dialog primitive;
 * used by the v2 chat attachment chips. The MUI `ImagePreview` stays for the
 * v1 / admin surfaces that still render it.
 */
export const ImagePreviewV2 = memo((props: ImagePreviewProps) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Dialog open={props.open} onOpenChange={(open) => !open && props.onClose()}>
      <DialogContent className="max-w-148">
        <DialogHeader>
          {/* Reserve room on the right so a long filename wraps clear of the
              Dialog's absolute close button instead of running under it. */}
          <DialogTitle className="break-all pr-6" data-testid="modal-title">
            {props.filename}
          </DialogTitle>
        </DialogHeader>
        {isLoading && <Skeleton className="h-[400px] w-full" />}
        <img
          src={props.url}
          alt={props.filename}
          onLoad={() => setIsLoading(false)}
          className={isLoading ? 'hidden' : 'block w-full'}
        />
      </DialogContent>
    </Dialog>
  );
});

ImagePreviewV2.displayName = 'ImagePreviewV2';
